import React from 'react';
import './Cases.css';

const cases = [
  {
    title: '某大型会计师事务所',
    desc: 'AI审计系统上线后，项目周期缩短40%',
    detail: '查看详情',
  },
  {
    title: '某国企内控审计',
    desc: '智能风险预警模块识别潜在风险点200+',
    detail: '查看详情',
  },
  {
    title: '某金融机构',
    desc: '自动化审计流程提升效率80%',
    detail: '查看详情',
  },
];

const Cases: React.FC = () => (
  <section className="cases">
    <h2>成功案例</h2>
    <div className="cases-list">
      {cases.map((item, idx) => (
        <div className="case-card" key={idx}>
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
          <a href="#" className="case-detail">{item.detail} &rarr;</a>
        </div>
      ))}
    </div>
  </section>
);

export default Cases; 